import { render, staticRenderFns } from "./SatelliteStatus.vue?vue&type=template&id=cf0c71f4&scoped=true"
import script from "./SatelliteStatus.vue?vue&type=script&lang=js"
export * from "./SatelliteStatus.vue?vue&type=script&lang=js"
import style0 from "./SatelliteStatus.vue?vue&type=style&index=0&id=cf0c71f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0c71f4",
  null
  
)

export default component.exports